import React, { useState } from 'react';
import { Input, Select, Text, Button } from 'v3/components';
import { Col, Row } from 'react-bootstrap';
import { useSnackbar } from 'v3/components/Snackbar';
import { cooperplaceApi } from 'services/api';
import moment from 'moment';
import { fetchByCityAndProvince } from 'utils/fetches';
import InputAddress from 'v3/components/InputAddress';
import InputCurrency from 'v3/components/Input/Currency/index';
import TextArea from 'v3/components/TextArea';
import { useFleetManagement } from '../../shared';
import formSchema from './validator';

function CreateNewOutsideTravel() {
  const {
    selected,
    setSelected,
    handleGetData,
    setIsCreateOpen,
  } = useFleetManagement();

  const [isFetching, setIsFetching] = useState(false);

  const [form, setForm] = useState({
    originCity: null,
    deliveryCity: null,
    collectDate: null,
    deliveryDate: null,
    travelType: null,
    observation: null,
    value: null,
  });

  const [errors, setErrors] = useState();
  const snackbar = useSnackbar();

  const handleClose = () => {
    setSelected(null);
    setForm({
      originCity: null,
      deliveryCity: null,
      collectDate: null,
      deliveryDate: null,
      travelType: null,
      observation: null,
      value: null,
    });
    setIsCreateOpen(false);
  };

  const handleConfirm = async () => {
    setIsFetching(true);
    const errorList = {};

    const payload = {
      vehicleManagementId: selected?.id,
      cityOrigin: form?.originCity?.id,
      cityDestination: form?.deliveryCity?.id,
      latOrigin: form?.originCity?.latitude,
      latDestination: form?.deliveryCity?.latitude,
      longOrigin: form?.originCity?.longitude,
      longDestination: form?.deliveryCity?.longitude,
      typeTravel: form?.travelType?.value,
      dateDestination:
        form?.deliveryDate && moment(form.deliveryDate, 'DD/MM/YYYY HH:mm').toISOString(),
      dateOrigin: form?.collectDate && moment(form.collectDate, 'DD/MM/YYYY HH:mm').toISOString(),
      observation: form?.observation,
      value: +form?.value,
    };

    try {
      await formSchema.validate(payload, {
        abortEarly: false,
      });

      try {
        await cooperplaceApi.post('fleet/management/travelOutside', payload);
        setForm({
          originCity: null,
          deliveryCity: null,
          collectDate: null,
          deliveryDate: null,
          travelType: null,
          observation: null,
          value: null,
        });

        await handleGetData();

        setIsCreateOpen(false);

        snackbar.show(
          <Text>
            {`Viagem externa para a placa ${selected?.plate?.plate} incluída com sucesso!`}
          </Text>,
          {
            type: 'success',
          },
        );
      } catch (error) {
        snackbar.show(
          <Text>
            {error?.response?.data?.error
              ? error.response.data.error
              : 'Error ao incluir viagem externa'}
          </Text>,
          {
            type: 'error',
          },
        );
      }
    } catch (error) {
      error.inner.forEach((err) => {
        errorList[err.path] = err.message;
      });
      setErrors(errorList);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <>
      <Row>
        <Col sm={12} md={8}>
          <InputAddress
            label="Cidade de origem *"
            typesRestriction={['(cities)']}
            placeholder="Busque uma cidade de origem..."
            removeCountryRestriction
            onSelectedAddress={async (place) => {
              const [city] = await fetchByCityAndProvince(place.city, place.province);
              setForm((prev) => ({
                ...prev,
                originCity: {
                  id: city?.id,
                  latitude: place?.lat,
                  longitude: place?.lng,
                },
              }));
              setErrors(null);
            }}
            error={errors?.latOrigin || errors?.longOrigin || errors?.cityOrigin}
          />
        </Col>
        <Col sm={12} md={4}>
          <Input
            label="Data Coleta *"
            type="datetime-local"
            onKeyDown={(event) => event.preventDefault()}
            onChange={({ target: { value: collectDate } }) => {
              setForm((prev) => ({
                ...prev,
                collectDate: moment(collectDate).format('DD/MM/YYYY HH:mm'),
              }));
              setErrors(null);
            }}
            error={errors?.dateOrigin}
          />
        </Col>
        <Col sm={12} md={8} className="mt-2">
          <InputAddress
            label="Cidade de destino *"
            typesRestriction={['(cities)']}
            placeholder="Busque uma cidade de destino..."
            removeCountryRestriction
            onSelectedAddress={async (place) => {
              const [city] = await fetchByCityAndProvince(place.city, place.province);
              setForm((prev) => ({
                ...prev,
                deliveryCity: {
                  id: city?.id,
                  latitude: place?.lat,
                  longitude: place?.lng,
                },
              }));
              setErrors(null);
            }}
            error={errors?.longDestination || errors?.cityDestination || errors?.latDestination}
          />
        </Col>
        <Col sm={12} md={4} className="mt-2">
          <Input
            label="Data entrega final *"
            type="datetime-local"
            onKeyDown={(event) => event.preventDefault()}
            onChange={({ target: { value: deliveryDate } }) => {
              setForm((prev) => ({
                ...prev,
                deliveryDate: moment(deliveryDate).format('DD/MM/YYYY HH:mm'),
              }));
              setErrors(null);
            }}
            error={errors?.dateDestination}
          />
        </Col>
        <Col sm={12} md={8} className="mt-2">
          <Select
            options={[
              { label: 'Viagem externa', value: 'OUTSIDE_TRAVEL' },
              { label: 'Viagem vazia', value: 'EMPTY_TRAVEL' },
            ]}
            label="Tipo de viagem *"
            value={form?.travelType}
            onChange={(travelType) => {
              setForm((prev) => ({ ...prev, travelType }));
              setErrors(null);
            }}
            error={errors?.typeTravel}
          />
        </Col>
        <Col sm={12} md={4} className="mt-2">
          <InputCurrency
            label="Valor"
            value={form?.value ? form?.value : '0.00'}
            onChange={(_, value) => setForm((prev) => ({ ...prev, value }))}
          />
        </Col>
        <Col sm={12} md={6} className="mt-2">
          <TextArea
            label="Observações"
            value={form?.observation}
            onChange={({ target: { value: observation } }) => {
              setForm((prev) => ({ ...prev, observation }));
            }}Cidade de destino
          />
        </Col>
      </Row>
      <Row style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
      }}>
        <Col xs="auto">
          <Button
            variant="secondary"
            onClick={handleClose}
            loading={isFetching}
          >
            Cancelar
          </Button>
        </Col>

        <Col xs="auto">
          <Button
            variant="primary"
            onClick={handleConfirm}
            loading={isFetching}
          >
            Adicionar
          </Button>
        </Col>
      </Row>
    </>
  )
}
export default CreateNewOutsideTravel;
